import { get } from "lodash"

const EMPTY_ARRAY = []

// this will fetch an array of { title, url } article object which is handled by ruta3 routing
// src/reducers/app/help-menu.js
export const getHelpArticles = state => get(state, "app.help-menu", EMPTY_ARRAY)
